import { render, staticRenderFns } from "./Embr.vue?vue&type=template&id=364813ff&scoped=true&"
import script from "./Embr.vue?vue&type=script&lang=js&"
export * from "./Embr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364813ff",
  null
  
)

export default component.exports